/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Permissions_Editroledescription3Inputs */

const en_usermanagement_permissions_editroledescription3 = /** @type {(inputs: Usermanagement_Permissions_Editroledescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set custom role permissions based on the selected role of`)
};

/**
* | output |
* | --- |
* | "Set custom role permissions based on the selected role of" |
*
* @param {Usermanagement_Permissions_Editroledescription3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_permissions_editroledescription3 = /** @type {((inputs?: Usermanagement_Permissions_Editroledescription3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Permissions_Editroledescription3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_permissions_editroledescription3(inputs)
});
export { usermanagement_permissions_editroledescription3 as "userManagement_permissions_editRoleDescription" }